var React = require('react');
module.exports = function () {
  return /* #__PURE__*/React.createElement('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '25',
    height: '25',
    viewBox: '0 0 25 25'
  }, /* #__PURE__*/React.createElement('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, /* #__PURE__*/React.createElement('circle', {
    className: 'fill',
    cx: '12.5',
    cy: '12.5',
    r: '12.5',
    fill: '#000'
  }), /* #__PURE__*/React.createElement('path', {
    className: 'border',
    fill: '#000',
    fillRule: 'nonzero',
    d: 'M12.5 23C18.299 23 23 18.299 23 12.5S18.299 2 12.5 2 2 6.701 2 12.5 6.701 23 12.5 23zm0 2C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25z'
  }), /* #__PURE__*/React.createElement('path', {
    className: 'checkmark',
    fill: '#000',
    d: 'M11.069 14.092l4.274-4.815a.766.766 0 0 1 1.18 0c.326.384.326.947 0 1.33l-4.668 5.249c-.069.18-.188.341-.354.461a.794.794 0 0 1-1.14-.35l-2.247-2.85a1.016 1.016 0 0 1 .305-1.29.787.787 0 0 1 1.14.35l1.51 1.915z'
  }), /* #__PURE__*/React.createElement('path', {
    className: 'plus',
    fill: '#000',
    d: 'M13 12h4v1h-4v4h-1v-4H8v-1h4V8h1v4z'
  })));
};